<template>
  <div>
    <div v-if="dateTime">
      <div v-if="layout == 'v'">
        <div class="text-start">
          {{ $filters.defaultDate(dateTime) }}
        </div>
        <div class="text-start">
          {{ $filters.defaultTime(dateTime) }}
        </div>
      </div>

      <div v-else-if="layout == 'h'" class="d-flex align-items-center">
        <span class="text-start me-2">
          {{ $filters.defaultDate(dateTime) }}
        </span>
        <span class="text-start">
          {{ $filters.defaultTime(dateTime) }}
        </span>
      </div>
    </div>
    <div v-else class="text-start">-</div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  props: {
    dateTime: {
      type: Object,
      default: () => {},
    },
    layout: {
      type: String,
      default: "v",
    },
  },
  methods: {},
  computed: {},
  watch: {},
  components: {},
};
</script>

<style></style>
